import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { Typography, Chip } from '@mui/material';
import { Folder } from '@mui/icons-material';
import Box from '@mui/material/Box';
import * as Utils from "services/UtilsService";
import { getFileIcon } from "actions/GlobalActions";
import { ReactComponent as File } from "assets/images/file.svg";
import { icons } from "constants/viewer";
import commonStyles, {
  
} from "styles/common";


type TPending= {
	p:{},
	text: string,
	date : string,
	status : string
}

function getIcon(entity: any, classes: any) {
	
    var fileName = getFileIcon(entity);
    //console.log("fileName:", fileName);
    if (!fileName) {
        return <File className={classes.icon} />;
    }
    const Icon = icons[fileName];
    return (
        <div className={classes.layerIcon}>
            <Icon className={classes.icon} />
        </div>
    );
}

function CustomLabel({ p, text, date, status }:TPending) {
	const { classes: common } = commonStyles();
	
	return (
	  	<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin:'4px 0', fontSize: 'small' }}>
			<div style={{width:'8%'}}>{getIcon(p, common)}</div>
			<div style={{width:'42%'}}>{text}</div>
			<div style={{ color:'#3DABE6', width: '25%' }}>{date}</div>
			<div style={{ width: '25%' }}>
				<Chip color={"success"} size={'small'} label={status}/>
			</div>
	  	</div>
	);
}

const PendingTasks = (props:any) => {
	const {project, id, tasks} = props;
	
	const define_status = (str: string) => {
		return typeof str === "string" && str.length > 0 ? str : "Pending processing...";
	};

	const renderLabelWithIcon = (icon:any, text:any) => (
		<Box display="flex" alignItems="center">
		{icon}
		<Typography variant="body2" sx={{ marginLeft: 1 }}>{text}</Typography>
		</Box>
	);

  	return (
		
		<TreeItem key={id} itemId={id} label={renderLabelWithIcon(<Folder sx={{ color: "rgb(255, 194, 72)" }}/>, project)}>
			{
				tasks.map((p: any, index: number) => {
					var pendingStatus =
					typeof p["partial_status"] === "string" && p["partial_status"].length > 0
						? define_status(p["partial_status"])
						: "Waiting in queue...";
						return <TreeItem key={"task-" + index} itemId={"task-" + id + '_' + index}  label={<CustomLabel p={p} text={p.name} date={Utils.formatDateWithTime(p.file_date)} status={pendingStatus}/>}/>
				})
			} 
		</TreeItem>
  	);
};

export { PendingTasks };
